import { useState } from "react";
import { Textarea } from "../../../components/ui/textarea";
import { Label } from "../../../components/ui/label";
import { dicts, LANGUAGES } from "../../../i18n";
import { Group, SaveBar, useDraft, useSectionSave } from "./shared";

const FAQ = [1, 2, 3, 4, 5, 6].flatMap((n) => [`faq_q${n}`, `faq_a${n}`]);
const GROUPS = [
  ["Hero (top of home page)", ["hero_eyebrow", "hero_title", "hero_sub", "hero_cta_join", "hero_cta_learn"]],
  ["Vision & mission", ["vm_title", "vision_text", "mission_text"]],
  ["Packages section", ["pk_title", "pk_sub"]],
  ["Testimonials", ["tm_title", "tm_sub", "tm_1", "tm_2", "tm_3"]],
  ["Help & FAQ", ["help_title", "help_sub", ...FAQ]],
  ["Contact section", ["contact_title", "contact_sub"]],
];

export const ContentSection = () => {
  const { settings, save, busy } = useSectionSave();
  const [content, setContent] = useDraft(settings.content || {});
  const [lang, setLang] = useState("en");
  const set = (k, v) => setContent({ ...content, [lang]: { ...(content[lang] || {}), [k]: v } });
  const clean = () => Object.fromEntries(Object.entries(content).map(([l, o]) => [l, Object.fromEntries(Object.entries(o).filter(([, v]) => v.trim()))]));
  return (
    <div className="space-y-6">
      <div className="lux-card flex flex-wrap items-center gap-2 p-4">
        <span className="mr-2 text-sm text-muted-foreground">Editing language:</span>
        {LANGUAGES.map((l) => (
          <button key={l.code} type="button" onClick={() => setLang(l.code)} className={lang === l.code ? "btn-gold !px-4 !py-1.5" : "btn-ghost-gold !px-4 !py-1.5"} data-testid={`content-lang-${l.code}`}>{l.label}</button>
        ))}
        <p className="w-full pt-2 text-xs text-muted-foreground">Leave a field empty to use the default text shown in grey.</p>
      </div>
      {GROUPS.map(([title, keys]) => (
        <Group key={title} title={title}>
          {keys.map((k) => (
            <div key={k} className="space-y-1.5">
              <Label className="font-mono text-[11px] text-muted-foreground">{k}</Label>
              <Textarea rows={k.length > 8 && /sub|text|_a|tm_\d/.test(k) ? 3 : 1} value={content[lang]?.[k] || ""} placeholder={dicts[lang][k] || dicts.en[k]}
                onChange={(e) => set(k, e.target.value)} data-testid={`content-${k}-input`} />
            </div>
          ))}
        </Group>
      ))}
      <div className="sticky bottom-4"><SaveBar onClick={() => save({ content: clean() })} busy={busy} testId="content-save-btn" /></div>
    </div>
  );
};
